import { InjectionToken } from "@angular/core";
import { EditorOptions } from "../types/editor-options";

/**
 * Provides an injection token to access Google Analytics DataLayer Collection
 */
export const NG_EDITOR_CONF = new InjectionToken<EditorOptions>(
  "ng-editor-default-config"
);
